import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSignupComponent implements OnInit {
    public name: string = '';
    public email: string = '';
    public password: string = '';
    public passwordConfirm: string = '';

    public errors: any = {};
    public emailChecked: boolean = false;
    public emailAvailable: boolean = false;
    public submitting: boolean = false;
    public signupSuccess: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async checkEmail() {
        this.errors.email = '';
        this.emailChecked = false;
        this.emailAvailable = false;

        if (!this.email.trim()) {
            this.errors.email = '이메일을 입력하세요.';
            await this.service.render();
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.email.trim())) {
            this.errors.email = '올바른 이메일 형식이 아닙니다.';
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("check_email", { email: this.email.trim() });
        this.emailChecked = true;
        if (code === 200 && data.available) {
            this.emailAvailable = true;
        } else {
            this.emailAvailable = false;
            this.errors.email = '이미 사용 중인 이메일입니다.';
        }
        await this.service.render();
    }

    public validate(): boolean {
        this.errors = {};
        let valid = true;

        if (!this.name.trim()) {
            this.errors.name = '이름을 입력하세요.';
            valid = false;
        }

        if (!this.email.trim()) {
            this.errors.email = '이메일을 입력하세요.';
            valid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email.trim())) {
                this.errors.email = '올바른 이메일 형식이 아닙니다.';
                valid = false;
            }
        }

        if (!this.password) {
            this.errors.password = '비밀번호를 입력하세요.';
            valid = false;
        } else if (this.password.length < 8) {
            this.errors.password = '비밀번호는 8자 이상이어야 합니다.';
            valid = false;
        }

        if (!this.passwordConfirm) {
            this.errors.passwordConfirm = '비밀번호 확인을 입력하세요.';
            valid = false;
        } else if (this.password !== this.passwordConfirm) {
            this.errors.passwordConfirm = '비밀번호가 일치하지 않습니다.';
            valid = false;
        }

        return valid;
    }

    public async signup() {
        if (!this.validate()) {
            await this.service.render();
            return;
        }

        this.submitting = true;
        await this.service.render();

        const { code, data } = await wiz.call("signup", {
            name: this.name.trim(),
            email: this.email.trim(),
            password: this.password
        });

        this.submitting = false;

        if (code === 200) {
            this.signupSuccess = true;
        } else {
            if (data?.message) {
                this.errors.general = data.message;
            } else {
                this.errors.general = '회원가입에 실패했습니다.';
            }
        }
        await this.service.render();
    }

    public goHome() {
        this.service.href('/');
    }
}

export default PageSignupComponent;